import "../css/B2BCapabilities_HowITWork.css";

export default function B2BCapabilities_HowItWork() {
	return (
		<section className="how-we-work-section">
			<div className="how-we-work-grid">
				{/* LEFT CONTENT */}
				<div className="work-content">
					<span className="section-tag">PROCESS & PARTNERS</span>
					<h2>How We Work</h2>

					<ul className="work-steps">
						<li>
							<span>01</span> Share Your Requirements
						</li>
						<li>
							<span>02</span> Design Development & Sampling
						</li>
						<li>
							<span>03</span> Confirmation & Order Finalization
						</li>
						<li>
							<span>04</span> Supervised Production
						</li>
						<li>
							<span>05</span> Packaging & Global Delivery
						</li>
					</ul>

					<p className="work-note">
						Clear communication, controlled production, defined
						timelines, and quality oversight at every stage.
					</p>

					<h2 className="mt-4">Who We Work With</h2>

					<div className="work-with">
						<span>Interior Designers & Studios</span>
						<span>Rug Importers & Wholesalers</span>
						<span>Hospitality & Contract Projects</span>
						<span>Private Label & Retail Brands</span>
					</div>
				</div>

				{/* RIGHT IMAGES */}
				<div className="container">
					<div className="mb-5 work-images">
						<img
							src="/images/B2BCap/howwework1.jpeg"
							alt="Rug design"
						/>
					</div>

					<div className="work-images">
						<img
							src="/images/B2BCap/howwework2.jpeg"
							alt="Rug texture"
						/>
					</div>
				</div>
			</div>
		</section>
	);
}
